<div style="display: inline-block; width: 100%">
    <div class="left-column">

        <div class="profile">
            <div class="row" *ngIf="user">
                <div class="menu"><i class="fas fa-bars"></i></div>
                <div class="line">
                    <div class="name">{{ user?.i }}</div>
                    <div class="avatar" [style.backgroundImage]="'url(' + url + (user? user.avatar : '') + ')'"></div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="CONFIG.forms">
            <ng-container *ngFor="let form of CONFIG.forms | keyvalue: defaultOrder">
                <button class="button"
                        [ngClass]="{selected: DATA.current_table == 'form_' + form.key}"
                        routerLink="/form/{{ form.key }}"
                >{{ form.value }}</button>
            </ng-container>
        </ng-container>

        <hr style="width: 100%">

        <ng-container *ngFor="let table of CONFIG.tables | keyvalue: defaultOrder">
            <div class="row">
                <button class="button"
                        [ngClass]="{selected: DATA.current_table == table.key}"
                        routerLink="/table/{{ table.key }}"
                >{{ table.value }}</button>
                <button class="button plus">
                    <i class="fas fa-plus"></i>
                </button>
            </div>
        </ng-container>
    </div>

    <div class="right-column">
        <router-outlet></router-outlet>
    </div>
</div>

<app-date-picker></app-date-picker>
